export const category = {
    labels: {
        name: "Nome",
        categories: "Categorias",
        category: "Categoria",
        subcategory: "Subcategoria",
        subcategories: "Subcategorias",
        description: "Descrição",
        add_subcategory: "Adicionar Subcategoria",
        delete_category: "Deletar Categoria",
        edit_category: "Editar Categoria",
        slug: "Slug",
    },
    placeholders: {
        name: "Informe o nome",
        description: "Informe a descrição",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_category: "Adicionar Categoria",
            add_subcategory: "Adicionar Subcategoria",
            del_category: "Excluir Categoria",
            del_subcategory: "Excluir Subcategoria",
        },
        messages: {
        },
    },
    texts: {
        del_category: "Você deseja mesmo deletar esta categoria?<br/>Todos os cadastros desta categoria serão deletados.",
    },
};
